import React from "react";
/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import ResumeAdd from "./ResumeAdd";
import ResumeEdit from "./ResumeEdit";
import log from "../lib/log";
import { loginState, configState } from "../lib/State";
import token_login from "../lib/token_login";
import get_session from "../lib/get_session";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { AppBar, Toolbar, IconButton } from "@mui/material";
import CenterSelect from "./CenterSelect";
import pr from "../lib/pr";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";
import SelectFCenter from "./SelectFCenter";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function Resume() {
    const [login, setLogin] = useState(loginState);
    const [loaded, setLoaded] = useState(false);
    const [rows, setRows] = useState([]);
    const [seq, setSeq] = useState(-1);
    const [showAdd, setShowAdd] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const token = localStorage.getItem("token");
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [popPhone, setPopPhone] = useState("Hello");
    const [centers, setCenters] = useState([]);
    const [tcid, setTcid] = useState('');
    const [fcid, setFcid] = useState('');
    const [resume_seq, setResume_seq] = useState(0);
    const [state, setState] = useState('');
    const [eCid, setEcid] = useState('');
    const [tcd, setTcd] = useState('');

    const open = Boolean(anchorEl);

    // 폼 데이타
    const [data, setData] = useState({
        sname: "",
        sphone: ""
    });

    const onHandleData = (e) => {
        setData((state) => {
            return { ...state, [e.target.name]: e.target.value };
        });
    };

    const columns = [
        { field: "id", headerName: "id", hide: true },
        { field: "resume_seq", headerName: "resume_seq", hide: true },
        { field: "cid", headerName: "cid", hide: true },
        { field: "tcd", headerName: "tcd", hide: true },
        { field: "subdate", headerName: "강사등록일", width: 160, align: "center" },
        {
            field: "name",
            headerName: "이름",
            width: 120,
        },
        { field: "cname", headerName: "센터명", width: 140, align: "center" },
        { field: "state", headerName: "등록여부", width: 120, align: 'center',
        renderCell: (params) => {
            const color = params.row.state !== "N" ? "#3096F4" : "gray";
            return <CheckCircleIcon sx={{ color: color }}></CheckCircleIcon>;
        }
        },
        { field: "onoff", headerName: "노출", width: 120, align: 'center',
        renderCell: (params) => {
            const color = params.row.onoff !== "N" ? "#3096F4" : "gray";
            return <LightbulbIcon sx={{ color: color }}></LightbulbIcon>;
        }
        },
        {
            field: "submit",
            headerName: "이력서관리",
            width: 120,
            align: "center",
            sortable: false,
            renderCell: (params) => {
                return (
                    <Button
                        value={params.row.seq}
                        variant="contained"
                        onClick={() => {
                            setShowEdit(true);
                            setSeq(params.row.id);
                            setResume_seq(params.row.resume_seq);
                            setEcid(params.row.cid);
                            setTcd(params.row.tcd);
                        }}
                    >
                        관리
                    </Button>
                );
            },
        },
    ];
    
    // const rows = [
    //   {
    //     id: 1,
    //     name: "Snow",
    //     phone: "000-0000-0000",
    //     sex: "남",
    //     age: 35,
    //     weight: 55,
    //   }
    // ];

    const onCloseAddPop = async () => {
        let result = await axios.post(configState.api + '/gympass_admin/resume_add_close', {
            token: token,
            cid: login.cid,
            level: login.level,
            mcd: login.mcd,
            resume_seq: resume_seq,
        })
        if (result.data.success === 1) {
            setShowAdd(false);
            load_data();
        }
    };

    const onCloseEditPop = () => {
        setShowEdit(false);
        load_data();
    };

    const onOpenAdd = async () => {
        let result = await axios.post(configState.api + '/gympass_admin/resume_add_open', {
            token: token,
            cid: login.cid,
            level: login.level,
            mcd: login.mcd,
        })
        if (result.data.success === 1) {
            setShowAdd(true);
            setResume_seq(result.data.resume_seq)
        }
        
    };

    // 리스트
    const load_data = async () => {
        console.log("load_data");
        let result = await axios.post(configState.api + "/gympass_admin/resume_list", {
            token: token,
            cid: login.cid,
            level: login.level,
            mcd: login.mcd,
            tcid: tcid,
            sname: data.sname,
            sphone: data.sphone,
            state: state,
        });
        log(result.data);
        if (result.data.success === 1) {
            setRows(result.data.rows);
        } else {
            Swal.fire(result.data.msg);
            return;
        }
    };

    // ======================= //
    // 로그인
    // ======================= //
    const start = async () => {
        let result;
        result = await get_login();
        setLogin(result.data.login);
        result = await is_admin(result.data.login);
        if (!result) {
            window.location.href = "/";
        }
        setLoaded(true);
    };
    useEffect(() => {
        start();
    }, []);

    // 리스트
    useEffect(() => {
        if (loaded && tcid !== '') {
            load_data();
        }
        setState('');
    }, [loaded, tcid]);

    // 팝업처리
    const onPopoverOver = (event, message) => {
        setPopPhone(message);
        setAnchorEl(event.currentTarget);
    };

    const onPopoverOut = (event) => {
        setAnchorEl(null);
    };

    const onSearchClick = async () => {
        load_data();
    };

    return (
        <>
            {loaded === false ? (
                <Loading></Loading>
            ) : (
                <Layout login={login}>
                    <Popover
                        id="mouse-over-popover"
                        sx={{
                            pointerEvents: "none",
                        }}
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "left",
                        }}
                        transformOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                        }}
                        onClose={onPopoverOut}
                        disableRestoreFocus
                    >
                        <Typography sx={{ p: 1 }}>{popPhone}</Typography>
                    </Popover>

                    <h3
                        css={css`
                            margin-top: 10px;
                        `}
                    >
                        이력서관리
                    </h3>

                    <Box
                        display="flex"
                        sx={{ maxWidth: 1300, alignItems: "center", mb: 1 }}
                    >
                        <Box>
                            <CenterSelect
                                login={login}
                                tcidParent={tcid}
                                setTcidParent={setTcid}
                            />
                        </Box>
                    </Box>

                    <Box display="flex" sx={{ mb: 1 }}>
                        {/* 이름 */}
                        <Box>
                            <TextField
                                sx={{ width: 120 }}
                                name="sname"
                                label="이름"
                                size="small"
                                onChange={onHandleData}
                                autoComplete="off"
                            ></TextField>
                        </Box>

                        {/* 연락처 */}
                        <Box>
                            <TextField
                                sx={{ width: 180, ml: 1 }}
                                name="sphone"
                                label="연락처"
                                size="small"
                                onChange={onHandleData}
                                autoComplete="off"
                            ></TextField>
                        </Box>
                        <FormControl>
                            <InputLabel>등록여부</InputLabel>
                            <Select
                                name="state"
                                css={css`
                                width: 130px;
                                `}
                                label="등록여부"
                                size="small"
                                value={state}
                                onChange={(e) => setState(e.target.value)}
                            >
                                <MenuItem value='Y'>
                                    등록
                                </MenuItem>
                                <MenuItem value='N'>
                                    미등록
                                </MenuItem>
                            </Select>
                        </FormControl>

                        <Button
                            sx={{ ml: 1, fontSize: 15 }}
                            variant="contained"
                            onClick={onSearchClick}
                            size="small"
                        >
                            조회
                        </Button>
                    </Box>

                    <DataGrid
                        css={css`
              max-width: 1300px;
              min-height: 500px;
            `}
                        rows={rows}
                        columns={columns}
                        pageSize={10}
                        rowsPerPageOptions={[5]}
                        checkboxSelection={false}
                        // onRowClick={(params) => {
                        //     setSeq(params.row.id);
                        //     setShowEdit(true);
                        // }}
                    />

                    <Dialog
                        open={showAdd}
                        fullWidth={true}
                        maxWidth="md"
                        TransitionComponent={Transition}
                        onClose={() => { }}
                    >
                        <AppBar sx={{ position: "static" }}>
                            <Toolbar>
                                <Box sx={{ flexGrow: 1 }}>
                                    <Typography style={{ fontSize: 18 }}>이력서추가</Typography>
                                </Box>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    onClick={onCloseAddPop}
                                    aria-label="close"
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Toolbar>
                        </AppBar>
                        <ResumeAdd
                            tcidParent={tcid}
                            login={login}
                            onCloseAddPop={onCloseAddPop}
                            resume_seq={resume_seq}
                        ></ResumeAdd>
                    </Dialog>

                    <Dialog
                        open={showEdit}
                        TransitionComponent={Transition}
                        onClose={() => { }}
                        maxWidth="md"
                    >
                        <AppBar sx={{ position: "static" }}>
                            <Toolbar>
                                <Box sx={{ flexGrow: 1 }}>
                                    <Typography style={{ fontSize: 18 }}>이력서관리</Typography>
                                </Box>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    onClick={onCloseEditPop}
                                    aria-label="close"
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Toolbar>
                        </AppBar>
                        <ResumeEdit
                            login={login}
                            seq={seq}
                            resume_seq={resume_seq}
                            eCid={eCid}
                            tcd={tcd}
                            onCloseEditPop={onCloseEditPop}
                            showEdit={showEdit}
                        ></ResumeEdit>
                    </Dialog>
                </Layout>
            )}
        </>
    )
}

export default Resume;